import Head from 'next/head';
import PropTypes from 'prop-types';
import { getTitle } from 'utils';

const SEO = ({
  title, brandTitle = true, description, image, keywords = [],
}) => (
  <Head>
    <title>{getTitle(title, brandTitle)}</title>
    <meta property="og:title" content={title} />
    <meta property="og:site_name" content="My Personality" />
    <meta property="og:type" content="website" />
    <meta name="description" content={description} />
    {keywords.length > 0 && <meta name="keywords" content={keywords.join(',')} />}
    <meta property="og:description" content={description} />
    {image && <meta property="og:image" content={image} />}
  </Head>
);

SEO.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  image: PropTypes.string,
};

export default SEO;
